module.exports = __webpack_public_path__ + "static/img/3.7e4cf1ce.png";